// React router that changes between home, workbook and createbonsai
import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
// import { bonsai } from "../libs/fakeDesignData";
import { getClients } from "../../libs/toggl/getClients";
import { useNavigateToTop } from "../../libs/useNavigateToTop";
import { getLastTimeSeenClient } from "../../libs/toggl/getLastTimeSeenClient";
import { Box, Divider, Stack, Typography } from "@mui/material";
import AppBarResourceList from "../../components/AppBar/ResourceList";
import AppBarPlanner from "../../components/AppBar/Planner";
import { getAllData } from "../../libs/firebase/firestore/getAllData";
import { uploadDataWithName } from "../../libs/firebase/firestore/uploadDataWithName";

function ClientBreif({ client, ...props }) {
  // state to hold the last time seen client
  const [lastTimeSeenClient, setLastTimeSeenClient] = React.useState({});
  useEffect(() => {
    // get the last time seen client

    // random number between 0 and 3000
    let randomTime = Math.floor(Math.random() * 3000);
    setTimeout(() => {
      getLastTimeSeenClient(
        client.id,
        (lastTimeSeenClient) => {
          setLastTimeSeenClient(lastTimeSeenClient);
        },
        (error) => {
          console.log(error);
        }
      );
    }, randomTime);
  }, []);

  // lastTimeSeenClient.start to number of days ago

  let daysAgo = Math.floor(
    (Date.now() - Date.parse(lastTimeSeenClient.start)) / 86400000
  );

  let daysAgoString = !isNaN(daysAgo) ? `${daysAgo} days ago` : "not this year";

  return (
    <Stack direction="row" spacing={2} {...props}>
      {/* <Typography>{client.id}</Typography> */}
      <Typography>{client.name}</Typography>
      <Typography>{daysAgoString}</Typography>
    </Stack>
  );
}

function ScreenPlannerLastVisit() {
  const navigate = useNavigateToTop();

  // state to hold clients
  const [clients, setClients] = React.useState([]);

  useEffect(() => {
    // get clients from toggl
    getClients((clients) => {
      setClients(clients);
    });
  }, []);

  // thin the clients to only be the ones i care about
  const clientsToCareAbout = [
    "lisa",
    "debbie",
    "marla",
    "elizabeth appleton",
    "heather",
    "glorianne",
    "elizabeth harvey",
  ];

  const clientsToCareAboutObjects = clients.filter((client) => {
    return clientsToCareAbout.includes(client.name.toLowerCase());
  });

  const handleCheckClientList = () => {
    // TODO, get the client list from toggl, and check that firebase has the same list
    // if not, then add the client to firebase
    // if so, then do nothing

    // get clients from toggl
    if (clients.length === 0) {
      console.log("no clients yet");
      return;
    }

    // get clients from firebase
    getAllData("clients", (firebaseClients) => {
      const firebaseClientNames = firebaseClients.map((client) => {
        return client.name;
      });

      // check if clients from toggl are in firebase
      clients.forEach((client) => {
        // if client is not in firebase, then add it
        if (!firebaseClientNames.includes(client.name)) {
          addClientToFirebase(client);
        } else {
          console.log("client in firebase", client.name);
        }

        // if client is in firebase, then do nothing
      });
    });
  };

  const addClientToFirebase = (client) => {
    // add client to firebase
    console.log("adding client to firebase", client);

    let data = {
      name: client.name,
    };

    uploadDataWithName(
      data,
      "clients",
      String(client.id),
      () => {
        console.log("client added to firebase", client.name);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  return (
    <Box>
      <AppBarPlanner onCheckClientList={handleCheckClientList} />

      <Box
        style={{
          padding: "2rem",
          margin: "auto 0",
        }}
      >
        {/* Title and subtitle */}
        <Typography variant="h5">Last visits</Typography>
        <Typography variant="subtitle1">
          Here tells you when the last time you visited a client was
        </Typography>

        <Divider
          sx={{
            my: 2,
          }}
        />

        {clientsToCareAboutObjects.map((client, index) => {
          return <ClientBreif key={index} client={client} />;
        })}
        {/* <ResourceListsTable
          onClick={(resourceList) => {
            navigate(`/resource-list/${resourceList.storageDocumentId}`);
          }}
          // onDelete={handleOnDelete}
          data={resourceLists}
        /> */}
      </Box>
    </Box>
    // <Routes>
    //   <Route path="/">
    //     {/* <Route index element={<ScreenCreateResourceLists />} /> */}
    //   </Route>
    // </Routes>
  );
}

export default ScreenPlannerLastVisit;
